import { render } from "./CxPasswordNote.vue?vue&type=template&id=5c33ef1e&ts=true"
import script from "./CxPasswordNote.vue?vue&type=script&lang=ts"
export * from "./CxPasswordNote.vue?vue&type=script&lang=ts"

import "./CxPasswordNote.vue?vue&type=style&index=0&id=5c33ef1e&lang=less"

import exportComponent from "/home/ec2-user/workspace/_ui_production_production-1.59.1/microfrontends/conx-ui-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__